export default class DataObject {
  [key: string]: any;
}
